import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { separerReference } from '../../../../lib/plan.js';
import styles from './Plan.module.css';

/**
 * Une référence d'origine, rangée qualifiée par sa source : `manuel:1042`. La
 * source se détache de l'identifiant, parce que deux logiciels peuvent
 * numéroter pareil et que seule la valeur qualifiée fait foi (`reprise.md`).
 * Une référence sans source (ancienne) se montre telle quelle.
 */
export function ReferenceOrigine({ valeur }: { valeur: string }): JSX.Element {
  const { t } = useTranslation('console');
  const { source, id } = separerReference(valeur);
  return (
    <span
      className={styles.reference}
      title={
        source === null
          ? t('plan.origine.libelleSansSource', { id })
          : t('plan.origine.libelle', { source, id })
      }
    >
      {source === null ? null : (
        <>
          <span className={styles.referenceSource}>{source}</span>
          <span className={styles.referenceSeparateur}>:</span>
        </>
      )}
      <span className={styles.referenceId}>{id}</span>
    </span>
  );
}
